import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalHelpComponent } from './modal-help.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalHelpComponent],
  exports: [ModalHelpComponent],
  providers: [],
})
export class ModalHelpModule {}
